import React from "react";
import { useFormContext } from "react-hook-form";
import { TextField } from "../../shared/form-fields/text-field";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import documentTypeAsset from "../../../assets/icons/ic-documento.png";

export const QuotationPopupDocumentTypeField: React.FC = () => {
    const rhForm = useFormContext();
    return (
        <div>
            <TextField
                data-testid="QuotationPopupDocumentTypeField"
                icon={<img src={documentTypeAsset} />}
                rhForm={rhForm}
                fieldDefinition={quotationPopupFormDefinition.documentType}
                readOnly
            />
        </div>
    );
};
